import { render, staticRenderFns } from "./enableTwoFac.vue?vue&type=template&id=fbf38686&"
import script from "./enableTwoFac.vue?vue&type=script&lang=js&"
export * from "./enableTwoFac.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports